import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles/";
import Icon from "@material-ui/core/Icon/";
import IconButton from "@material-ui/core/IconButton/";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import QuickView from "./QuickView";
import ConfirmChangeStatusDialog from "./ConfirmChangeStatusDialog";
import toggleOnIcon from "../../assets/icons/icon-toggle-on.svg";
import toggleOffIcon from "../../assets/icons/icon-toggle-off.svg";
import { RiSearchLine } from "react-icons/ri";
import {
  DeleteIcon,
  EditIcon,
  MailIcon,
  PlayIcon,
  StopIcon
} from "../../components/IconsSVG";
import {
  Refresh,
  Backspace,
  PictureAsPdf,
  Visibility,
  Timelapse,
  Timer
} from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  button: {
    margin: "0 2px",
    "& svg": {
      fill: "#807e80"
    },
    "&:hover": {
      "& svg": {
        fill: "#4672C5"
      }
    }
  },
  buttonActive: {
    margin: "0 2px",
    "& svg": {
      fill: "#4672C5"
    },
    "&:hover": {
      "& svg": {
        fill: "#807e80"
      }
    }
  },
  div: {
    display: "flex",
    flexDirection: "row"
  }
}));

export default function CrudActions({
  actions,
  onConfirmDelete,
  onConfirmClear,
  onConfirmRevert,
  onConfirmChangeStatus,
  onConfirmInactive,
  module,
  id,
  obj,
  onViewDetails,
  onViewCertified,
  onConfirmResendEmail,
  onConfirmPlay,
  onConfirmStop,
  onConfirmTimeBank,
  accessTimeBank,
  handleEdit,
  pageOrigin,
  align,
  path,
  onQuickView
}) {
  const classes = useStyles();
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [confirmClear, setConfirmClear] = React.useState(false);
  const [confirmRevert, setConfirmRevert] = React.useState(false);
  const [confirmChangeStatus, setConfirmChangeStatus] = React.useState(false);
  const [confirmResend, setConfirmResend] = React.useState(false);
  const [confirmPlay, setConfirmPlay] = React.useState(false);
  const [confirmQuickView, setConfirmQuickView] = React.useState(false);
  const [confirmInactive, setConfirmInactive] = React.useState(
    onConfirmInactive ?? true
  );
  const [confirmTimeBank, setConfirmTimeBank] = React.useState(false);

  function toggleConfirmDialog(e, state) {
    e.stopPropagation();
    setConfirmDelete(state);
  }

  function toggleConfirmRevertDialog(state) {
    setConfirmRevert(state);
  }

  function toggleConfirmClearDialog(state) {
    setConfirmClear(state);
  }

  function toggleChangeStatusDialog(state) {
    setConfirmChangeStatus(state);
  }

  function togglePlayDialog(e, state) {
    e.stopPropagation();
    setConfirmPlay(state);
  }

  function toggleResendDialog(state) {
    setConfirmResend(state);
  }

  function toggleQuickView(state) {
    setConfirmQuickView(state);
  }

  function toggleConfirmTimeBank(state) {
    setConfirmTimeBank(state);
  }

  function handleConfirmDelete(e, id) {
    toggleConfirmDialog(e, false);
    onConfirmDelete(id);
  }

  function handleConfirmClear(id) {
    toggleConfirmClearDialog(false);
    onConfirmClear(id);
  }

  function handleConfirmRevert(id) {
    toggleConfirmRevertDialog(false);
    onConfirmRevert(id);
  }

  function handleChangeStatus(id) {
    toggleChangeStatusDialog(false);
    onConfirmChangeStatus(id);
  }

  function handlePlay(e, obj) {
    togglePlayDialog(e, false);
    onConfirmPlay(obj);
  }

  function handleViewDetails(obj) {
    onViewDetails(obj);
  }

  function handleEditObj(e, obj) {
    e.stopPropagation();
    handleEdit(obj);
  }

  function handleViewCertified(obj) {
    onViewCertified(obj);
  }

  function handleResendMail(obj) {
    toggleResendDialog(false);
    onConfirmResendEmail(obj);
  }

  function handleQuickView(obj) {
    toggleQuickView(false);
    onQuickView(obj);
  }

  function handleConfirmTimeBank(id) {
    toggleConfirmTimeBank(false);
    onConfirmTimeBank(id);
  }

  return (
    <div className={classes.div} style={{ justifyContent: align ?? "center" }}>
      {actions && actions.includes("toggle") && (
        <>
          <ConfirmChangeStatusDialog
            open={confirmChangeStatus}
            closeDialog={() => setConfirmChangeStatus(false)}
            confirm={() => handleChangeStatus(obj)}
            message={`Deseja ${
              obj && !obj.deletionDate ? "inativar" : "ativar"
            } o registro selecionado?`}
            title="Confirmação"
          />

          {obj && !obj.deletionDate ? (
            <IconButton
              size="small"
              color="primary"
              className={classes.button}
              title="Inativar"
              onClick={() =>
                confirmInactive
                  ? toggleChangeStatusDialog(true)
                  : handleChangeStatus(obj)
              }
            >
              <img src={toggleOnIcon} alt="Inativar" />
            </IconButton>
          ) : (
            <IconButton
              size="small"
              className={classes.button}
              title="Ativar"
              onClick={() => toggleChangeStatusDialog(true)}
            >
              <img src={toggleOffIcon} alt="Ativar" />
            </IconButton>
          )}
        </>
      )}

      {actions && actions.includes("edit") && (
        <Link
          to={`/admin/${module}/${id}/editar${
            pageOrigin ? "?origin=" + pageOrigin : ""
          }`}
        >
          <IconButton
            size="small"
            className={classes.button}
            title="Editar registro"
          >
            <EditIcon />
          </IconButton>
        </Link>
      )}

      {actions && actions.includes("revert") && (
        <>
          <ConfirmDeleteDialog
            open={confirmRevert}
            title="Confirmação"
            message="Deseja realmente reverter a linha de registro?"
            closeDialog={() => toggleConfirmRevertDialog(false)}
            confirm={() => handleConfirmRevert(id)}
          />

          <IconButton
            size="small"
            className={classes.button}
            title="Reverter registro original da linha"
            onClick={() => toggleConfirmRevertDialog(true)}
          >
            <Refresh fontSize="small" />
          </IconButton>
        </>
      )}

      {actions && actions.includes("clear") && (
        <>
          <ConfirmDeleteDialog
            open={confirmClear}
            title="Confirmação"
            message="Deseja realmente limpar a linha de registro?"
            closeDialog={() => toggleConfirmClearDialog(false)}
            confirm={() => handleConfirmClear(id)}
          />

          <IconButton
            size="small"
            className={classes.button}
            title="Limpar registros da linha"
            onClick={() => toggleConfirmClearDialog(true)}
          >
            <Backspace fontSize="small" />
          </IconButton>
        </>
      )}

      {actions && actions.includes("play") && (
        <>
          <ConfirmChangeStatusDialog
            open={confirmPlay}
            confirm={e => handlePlay(e, obj)}
            closeDialog={e => togglePlayDialog(e, false)}
            message="Deseja iniciar um novo timer, contendo as mesmas informações de Cliente, Projeto, Atividade, Solicitante da demanda e Demanda?"
            hideTitle
          />
          <IconButton
            color="primary"
            size="small"
            title="Iniciar timer"
            className={classes.button}
            onClick={e => togglePlayDialog(e, true)}
          >
            <PlayIcon />
          </IconButton>
        </>
      )}

      {actions && actions.includes("stop") && (
        <IconButton
          color="primary"
          size="small"
          title="Iniciar timer"
          className={classes.button}
          onClick={e => onConfirmStop(e, obj)}
        >
          <StopIcon />
        </IconButton>
      )}

      {actions && actions.includes("edit-form") && (
        <IconButton
          onClick={e => handleEditObj(e, obj)}
          size="small"
          className={classes.button}
          title="Editar registro"
        >
          <EditIcon />
        </IconButton>
      )}

      {actions && actions.includes("individual-logs") && (
        <Link to={path}>
          <IconButton
            size="small"
            className={classes.button}
            title="Visualizar Logs"
          >
            <Visibility fontSize="small" />
          </IconButton>
        </Link>
      )}

      {actions && actions.includes("delete") && (
        <>
          <ConfirmDeleteDialog
            open={confirmDelete}
            closeDialog={e => toggleConfirmDialog(e, false)}
            confirm={e => handleConfirmDelete(e, id)}
          />

          <IconButton
            size="small"
            className={classes.button}
            title="Excluir registro"
            onClick={e => toggleConfirmDialog(e, true)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}

      {actions && actions.includes("soft-delete") && (
        <>
          <ConfirmDeleteDialog
            open={confirmDelete}
            closeDialog={e => toggleConfirmDialog(e, false)}
            confirm={e => handleConfirmDelete(e, id)}
            message="Ao clicar em confirmar você excluirá o registro."
          />

          <IconButton
            size="small"
            className={classes.button}
            title="Excluir registro"
            onClick={e => toggleConfirmDialog(e, true)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}

      {actions && actions.includes("resend") && (
        <>
          <ConfirmChangeStatusDialog
            open={confirmResend}
            closeDialog={() => setConfirmResend(false)}
            confirm={() => handleResendMail(obj)}
            message="Deseja reenviar um email de ativação para o usuário selcionado?"
            title="Confirmação"
          />

          <IconButton
            size="small"
            color="inherit"
            className={classes.button}
            title="Reenviar email de confirmação"
            onClick={() => toggleResendDialog(true)}
          >
            <MailIcon />
          </IconButton>
        </>
      )}

      {actions && actions.includes("show") && (
        <IconButton
          // color='primary'
          onClick={() => handleViewDetails(obj)}
          size="small"
          className={classes.button}
          title="Visualizar detalhes"
        >
          <Icon fontSize="small">visibility</Icon>
        </IconButton>
      )}

      {actions && actions.includes("certified") && (
        <IconButton
          onClick={() => handleViewCertified(obj)}
          size="small"
          className={classes.button}
          title="Baixar certificado em PDF"
        >
          <PictureAsPdf fontSize="small" />
        </IconButton>
      )}

      {actions && actions.includes("quick-view") && (
        <>
          <QuickView
            open={confirmQuickView}
            closeDialog={() => setConfirmQuickView(false)}
            confirm={() => handleQuickView()}
            title="Visualização Rápida"
            obj={obj}
          />

          <IconButton
            onClick={() => toggleQuickView(true)}
            size="small"
            className={classes.button}
            title="Visualização rápida"
          >
            <RiSearchLine />
          </IconButton>
        </>
      )}

      {actions && actions.includes("time-bank") && (
        <>
          <ConfirmDeleteDialog
            open={confirmTimeBank}
            title="Confirmação"
            message="Deseja alterar o acesso ao Banco de Horas deste profissional?"
            closeDialog={() => toggleConfirmTimeBank(false)}
            confirm={() => handleConfirmTimeBank(id)}
          />

          <IconButton
            size="small"
            className={accessTimeBank ? classes.buttonActive : classes.button}
            title={
              accessTimeBank
                ? "Remover permissão para adição/consumo ao Banco de Horas"
                : "Adicionar permissão para adição/consumo ao Banco de Horas"
            }
            onClick={() => toggleConfirmTimeBank(true)}
          >
            <Timer fontSize="small" />
          </IconButton>
        </>
      )}
    </div>
  );
}
